export enum TourStatusEnum {
  draft = 'draft',
  archived = 'archived',
  waiting = 'waiting',
  pending_approval = 'pending_approval',
  rejected_approval = 'rejected_approval',
  active = 'active',
  cancel_draft = 'cancel_draft',
  pending_cancel_approval = 'pending_cancel_approval',
  canceled = 'canceled',
  close_draft = 'close_draft',
  pending_close_approval = 'pending_close_approval',
  closed = 'closed',
  revert_close_draft = 'revert_close_draft',
  pending_revert_close_approval = 'pending_revert_close_approval',
}
